import { LanguagesEnum } from "@/enums";

export default Object.freeze({
  [LanguagesEnum.fa]: {
    direction: "rtl",
    data: {
      TodayText: "امروز",
      Sunrise: "طلوع آفتاب",
      Sunset: "غروب آفتاب",
      Humidity: "رطوبت هوا",
      Wind: "سرعت باد",
      SearchCityDialogTitle: "انتخاب موقعیت مکانی",
      SearchCityDialogText: "شهر مورد نظر را انتخاب کنید:",
      SearchCityDialogSubmit: "تایید",
      SearchCityDialogCancel: "انصراف",
      EnterCityName: "نام شهر را وارد کنید",
    },
  },
  [LanguagesEnum.en]: {
    direction: "ltr",
    data: {
      TodayText: "Today",
      Sunrise: "Sunrise",
      Sunset: "Sunset",
      Humidity: "Humidity",
      Wind: "Wind",
      SearchCityDialogTitle: "Select a location",
      SearchCityDialogText: "Choose your city:",
      SearchCityDialogSubmit: "submit",
      SearchCityDialogCancel: "cancel",
      NoServiceText: `The service is not currently available.<br /> We are truly sorry for the inconvenience.`,
      EnterCityName: "enter city name",
    },
  },
  [LanguagesEnum.es]: {
    direction: "ltr",
    data: {
      TodayText: "Hoy dia",
      Sunrise: "Amanecer",
      Sunset: "Puesta de sol",
      Humidity: "Humedad",
      Wind: "viento",
      SearchCityDialogTitle: "Selecciona una ubicación",
      SearchCityDialogText: "Elija su ciudad deseada:",
      SearchCityDialogSubmit: "enviar",
      SearchCityDialogCancel: "cancelar",
      NoServiceText: `El servicio no está disponible actualmente.<br/> Sentimos mucho las molestias.`,
      EnterCityName: "ingrese el nombre de la ciudad",
    },
  },
  [LanguagesEnum.ar]: {
    direction: "rtl",
    data: {
      TodayText: "اليوم",
      Sunrise: "شروق الشمس",
      Sunset: "غروب",
      Humidity: "رطوبة",
      Wind: "سرعة الرياح",
      SearchCityDialogTitle: "اختر موقعا",
      SearchCityDialogText: "اختر مدينة:",
      SearchCityDialogSubmit: "إرسال",
      SearchCityDialogCancel: "إلغاء",
      NoServiceText: "الخدمة غير متوفرة حاليا.<br /> نحن حقا آسفون للإزعاج.",
      EnterCityName: "أدخل اسم المدينة",
    },
  },
  [LanguagesEnum.az]: {
    direction: "ltr",
    data: {
      TodayText: "Bu gün",
      Sunrise: "Günəşin doğuşu",
      Sunset: "Gün batımı",
      Humidity: "Rütubət",
      Wind: "Külək sürəti",
      SearchCityDialogTitle: "Məkan seçin",
      SearchCityDialogText: "Şəhərinizi seçin:",
      SearchCityDialogSubmit: "Təsdiq edin",
      SearchCityDialogCancel: "ləğv et",
      NoServiceText:
        "Xidmət hazırda mövcud deyil.<br /> Narahatçılığa görə həqiqətən üzr istəyirik.",
      EnterCityName: "şəhər adını daxil edin",
    },
  },
  [LanguagesEnum.ur]: {
    direction: "rtl",
    data: {
      TodayText: "آج",
      Sunrise: "طلوع آفتاب",
      Sunset: "غروب آفتاب",
      Humidity: "نمی",
      Wind: "ہوا کی رفتار",
      SearchCityDialogTitle: "ایک مقام منتخب کریں",
      SearchCityDialogText: "اپنے شہر کا انتخاب کریں:",
      SearchCityDialogSubmit: "جمع کرائیں",
      SearchCityDialogCancel: "منسوخ",
      NoServiceText:
        "سروس فی الحال دستیاب نہیں ہے۔<br /> ہم زحمت کے لیے واقعی معذرت خواہ ہیں۔",
      EnterCityName: "شہر کا نام درج کریں",
    },
  },
});
